@if (true) {<h1 class="pageTitle" id="skipLinkTarget" tabIndex="0" [innerHTML]="pageTitleService.getPageTitle()"></h1>}